import { render, staticRenderFns } from "./ChildCourse.vue?vue&type=template&id=a1306c94"
import script from "./ChildCourse.vue?vue&type=script&lang=js"
export * from "./ChildCourse.vue?vue&type=script&lang=js"
import style0 from "./ChildCourse.vue?vue&type=style&index=0&id=a1306c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports